import WebFont from "webfontloader";
import axios from "axios";
const tempKey = "AIzaSyA2OfaAMz8ceRCKk1nTdfg6asRko26NLV8";

const loadFonts = () => {
  axios
    .get(
      `https://www.googleapis.com/webfonts/v1/webfonts?key=${tempKey}&sort=POPULARITY&$.xgafv=1`
    )
    .then((res) => {
      let temp = res.data.items.slice(1, 60 + 1);
      temp = temp.map((t) => {
        return {
          value: t.family,
          label: t.family,
        };
      });
      temp.push({ value: "Supermercado One", label: "Supermercado One" });
      temp.push({ value: "Fredoka One", label: "Fredoka One" });

      WebFont.load({
        google: {
          families: temp.map((t) => t.value),
        },
      });
      // setFontFamilies(temp);
    })
    .catch((err) => console.log(err));
};

export default loadFonts;
